import React from 'react'
import PropTypes from 'prop-types'
import Button from 'react-bootstrap/lib/Button';
import { defaultMessages } from '../../../../libs/i18n/default'
import TrackableButton from './TrackableButton'
import { connect } from 'react-redux';

const mapStateToProps = (state) =>
  ({
    progressSavedMessage: state.territory.show_wizard_progress_saved_message
  });

class ButtonGroup extends React.Component {
  constructor(){
    super()
    this.state = {
      pressed: false
    }
    this.icon = this.icon.bind(this);
    this.dummyButton = this.dummyButton.bind(this);
    this.backButton = this.backButton.bind(this);
    this.skipButton = this.skipButton.bind(this);
    this.submitButton = this.submitButton.bind(this);
    this.submitClick = this.submitClick.bind(this);
  }
  icon() {
    if (this.state.pressed){
      return(<i className="fa fa-fw fa-spinner fa-spin" />);
    } else {
      return(this.props.intl.formatMessage(defaultMessages.clientCommonButtonsContinue));
    }
  }
  submitClick = (e) => {
    this.setState({pressed: true}, () => {
      if (this.props.submitFunc) {
        this.props.submitFunc(e)
      } else if (this.props.continueFunc) {
        this.props.continueFunc(e)
      }
    })
  }
  dummyButton = (position='') => {
    return(
      <Button
        type="submit"
        style={{visibility: 'hidden'}}
        className={"btn-primary btn-fixed-width " + position} />
      )
  }
  backButton = () => {
    if (this.props.backFunc !== undefined) {
      return(
        <TrackableButton
          type="submit"
          className='btn-primary btn-fixed-width pull-left'
          page={this.props.page}
          user={this.props.user}
          text={this.props.intl.formatMessage(defaultMessages.clientCommonButtonsBack)}
          onClick={this.props.backFunc}/>
        );
    } else {
      return(
        this.dummyButton('pull-left')
      )
    }
  }
  skipButton = () => {
    if (this.props.skipFunc !== undefined) {
      return(
        <TrackableButton
          type={this.props.continueFunc ? undefined : 'submit'}
          className={`btn-default${!this.props.skipText && ' btn-fixed-width'}`}
          page={this.props.page}
          user={this.props.user}
          text={this.props.skipText || this.props.intl.formatMessage(defaultMessages.clientCommonButtonsSkip)}
          onClick={this.props.skipFunc}/>
        );
    } else {
      return(
        this.dummyButton()
      )
    }
  }
  submitButton = () => {
    if (this.props.submitFunc !== undefined) {
      return(
        <TrackableButton
          type="submit"
          className='btn-primary btn-fixed-width pull-right'
          style={{marginLeft: '10px'}}
          page={this.props.page}
          user={this.props.user}
          text={this.icon()}
          disabled={this.props.disableSubmit}
          onClick={this.submitClick}
          icon={this.icon}/>
        );
    } else if (this.props.continueFunc) {
      return(
        <TrackableButton
          className='btn-primary btn-fixed-width pull-right'
          style={{marginLeft: '10px'}}
          page={this.props.page}
          user={this.props.user}
          text={this.icon()}
          disabled={this.props.disableSubmit}
          onClick={this.submitClick}
          icon={this.icon} />
      );
    } else {
      return(
        this.dummyButton('pull-right')
      )
    }
  }
  render(){
    return (
      <div>
        <div className='button-spacer'></div>
        <div className='form-group text-center form-footer'>
          {this.backButton()}
          {this.submitButton()}
          {this.skipButton()}
        </div>
        {
          this.props.progressSavedMessage &&
          <div className='progress-saved form-footer'>
            Your progress has been saved, if you exit this page you’ll be returned here next time you sign in
          </div>
        }
      </div>
    )
  }
};

ButtonGroup.propTypes = {
  intl: PropTypes.object
};

export default connect(mapStateToProps)(ButtonGroup);
